import { render, staticRenderFns } from "./Dispose.vue?vue&type=template&id=061ead32&scoped=true"
import script from "./Dispose.vue?vue&type=script&lang=js"
export * from "./Dispose.vue?vue&type=script&lang=js"
import style0 from "./Dispose.vue?vue&type=style&index=0&id=061ead32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ead32",
  null
  
)

export default component.exports